import { PeerGroupListItem, LayoutListItem } from './my-account-list-item';

export class UserPeerGroups {
    filters: PeerGroupListItem[] = new Array<PeerGroupListItem>();
    layouts: LayoutListItem[] = new Array<LayoutListItem>();
}
